module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_4",
      "title": "[Pg 4]"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "Fourth_Day"
    }
  }, [_vm._v("Fourth Day.")])]), _vm._v(" "), _c('div', {
    staticClass: "figcenter4",
    attrs: {
      "id": "i08"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "",
      "id": "id-3761220976608827055",
      "src": "Images/img0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse1"
  }, [_vm._v("For Heaven’s sake")]), _vm._v(" "), _c('div', {
    staticClass: "verse4"
  }, [_vm._v("let us")]), _vm._v(" "), _c('div', {
    staticClass: "verse5"
  }, [_vm._v("examine sacredly")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("whether there is any")]), _vm._v(" "), _c('div', {
    staticClass: "verse5"
  }, [_vm._v("wrong entrusted")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("to us to set right.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Little Dorrit.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Surprises, like misfortunes,")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("rarely come alone.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Dombey and Son.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("What the poor are to the poor is little known")]), _vm._v(" "), _c('div', {
    staticClass: "verse1"
  }, [_vm._v("excepting to themselves and God.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Bleak House.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("An honest man is one of the few great works")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("that can be seen for nothing.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Martin Chuzzlewit.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Thinking begets thinking.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Oliver Twist.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0